var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-view",style:({
        'display':'flex',
        'align-items': 'center',
        'justify-content': _vm.viewProps.textAlign,
        'font-size': this.$util.num2px(_vm.viewProps.fontSize),
        'font-weight': _vm.viewProps.fontWeight,
        'color': _vm.viewProps.color})},[_c('pre',[_vm._v(_vm._s(_vm.viewProps.dataConfig.data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }